import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'swiper/swiper-bundle.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
//引入echarts
import * as echarts from 'echarts'
//vue全局注入echarts
Vue.prototype.$echarts = echarts;

Vue.use(ElementUI);

Vue.config.productionTip = false
Vue.prototype.$pageSizeList = [10, 20, 30, 50, 80, 100, 200, 500]
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
